export default "__VITE_ASSET__CTwpfNFd__"